import React from "react";
import BreadCrumbs from "../common/BreadCrumbs";

const TermsAndConditions = () => {
  return (
    <>
      <BreadCrumbs
        title="Terms & Conditions"
        description="Our Terms & Conditions"
      />
      <div className="container my-5 terms-conditions-area">
        <p>
          Welcome to <strong>AppThing Technologies</strong>. These Terms and
          Conditions govern your access to and use of our website, services, and
          products. By accessing or using our platform, you acknowledge that you
          have read, understood, and agree to be bound by these terms. If you do
          not agree, you must discontinue use immediately.
        </p>

        <br />
        <h3>A. General Terms</h3>
        <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
          <li>
            <strong>Acceptance of Terms:</strong> By accessing our website or
            services, you agree to comply with these Terms & Conditions and all
            applicable laws. Continued use indicates your acceptance, even if
            you do not create an account or formally register with us.
          </li>
          <li>
            <strong>Amendments:</strong> AppThing Technologies reserves the
            right to update, modify, or replace these Terms & Conditions at any
            time. Updated versions will be posted on our website, and it is your
            responsibility to review them periodically. Your continued use of
            our services after changes means you accept the revised terms.
          </li>
          <li>
            <strong>Eligibility:</strong> You must be at least 18 years old (or
            the legal age of majority in your jurisdiction) to use our services.
            By using our platform, you confirm that you meet these eligibility
            requirements.
          </li>
        </ul>

        <br />
        <h3>B. Use of Our Services</h3>
        <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
          <li>
            <strong>Permitted Use:</strong> Our services are provided for lawful
            business and personal purposes only. You agree not to misuse,
            exploit, or interfere with our platform. Any unauthorized or illegal
            use will result in suspension or termination of access.
          </li>
          <li>
            <strong>Prohibited Activities:</strong> You may not use our services
            to distribute malware, engage in hacking, perform fraudulent
            transactions, or upload harmful content. Any attempt to disrupt or
            bypass our security systems will result in strict legal action.
          </li>
          <li>
            <strong>Account Responsibility:</strong> If you create an account,
            you are responsible for maintaining the confidentiality of your
            login details. Any actions taken using your account will be deemed
            your responsibility, whether performed by you or a third party.
          </li>
        </ul>

        <br />
        <h3>C. Intellectual Property Rights</h3>
        <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
          <li>
            <strong>Ownership:</strong> All website content, including text,
            graphics, logos, code, and software, is the exclusive property of
            AppThing Technologies. Unauthorized use, copying, or distribution of
            our content is strictly prohibited.
          </li>
          <li>
            <strong>Limited License:</strong> We grant you a non-exclusive,
            non-transferable license to access and use our website and services
            for personal or business use. This license does not allow resale,
            duplication, or unauthorized exploitation of our materials.
          </li>
          <li>
            <strong>Trademarks:</strong> All trademarks, logos, and service
            marks displayed are the property of AppThing Technologies or our
            partners. Use of these marks without prior written permission is not
            permitted.
          </li>
        </ul>

        <br />
        <h3>D. Limitation of Liability</h3>
        <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
          <li>
            <strong>No Guarantee:</strong> While we strive to provide reliable
            and secure services, AppThing Technologies does not guarantee
            uninterrupted availability, accuracy of information, or complete
            error-free operation.
          </li>
          <li>
            <strong>Disclaimer of Damages:</strong> We are not responsible for
            any direct, indirect, incidental, or consequential damages resulting
            from your use of our website or services. This includes, but is not
            limited to, loss of data, revenue, profits, or goodwill.
          </li>
          <li>
            <strong>Third-Party Services:</strong> Any use of third-party
            services, links, or tools provided on our platform is at your own
            risk. We disclaim liability for issues arising from third-party
            websites or service providers.
          </li>
        </ul>

        <br />
        <h3>E. Termination</h3>
        <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
          <li>
            <strong>Termination by Us:</strong> AppThing Technologies reserves
            the right to suspend or terminate your account at any time for
            violating these Terms & Conditions or engaging in unlawful
            activities.
          </li>
          <li>
            <strong>Termination by You:</strong> You may discontinue use of our
            services and request account closure at any time by contacting us at{" "}
            <a href="mailto:info@appthing.in">info@appthing.in</a>.
          </li>
          <li>
            <strong>Effect of Termination:</strong> Termination will not affect
            rights or obligations accrued before termination. Any outstanding
            payments or liabilities remain enforceable even after account
            closure.
          </li>
        </ul>

        <br />
        <h3>F. Governing Law & Dispute Resolution</h3>
        <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
          <li>
            <strong>Applicable Law:</strong> These Terms & Conditions shall be
            governed by and construed in accordance with the laws of India,
            without regard to conflict-of-law principles.
          </li>
          <li>
            <strong>Dispute Resolution:</strong> Any disputes arising from or
            related to these Terms & Conditions shall first be attempted to be
            resolved amicably. If not resolved, disputes will be subject to the
            exclusive jurisdiction of the courts located in Ranchi, Jharkhand.
          </li>
          <li>
            <strong>Arbitration:</strong> In certain cases, disputes may be
            referred to binding arbitration in accordance with the Arbitration
            and Conciliation Act, 1996.
          </li>
        </ul>

        <br />
        <h3>G. Contact Information</h3>
        <p>
          If you have questions or concerns about these Terms & Conditions,
          please contact us at:
        </p>
        <p>
          <strong>AppThing Technologies</strong> <br />
          Email: <a href="mailto:info@appthing.in">info@appthing.in</a> <br />
          Website: <a href="https://www.appthing.in">www.appthing.in</a>
        </p>
      </div>
    </>
  );
};

export default TermsAndConditions;
